import { z, isoZ } from 'my-zod'
import { gearUsageFragment } from '../../utilities/gear-usage'

export const vehicleImage = z
  .object({
    imageType: z.number(),
    imageNotes: z.string().nullable(),
    imageFileUrl: z.string().nullable(),
    imageFileName: z.string().nullable(),
    imageOrigin: z.string().nullable()
  })
  .partial()

export type vehicleImage = z.infer<typeof vehicleImage>

export const damageReportElement = z
  .object({
    itemName: z.string(),
    price: z.number(),
    currency: z.string(),
    quantity: z.number(),
    imageUrl: z.string()
  })
  .partial()

export type damageReportElement = z.infer<typeof damageReportElement>

export const vehicleUseHistoryModel = z.object({
  id: z.string().uuid(),
  operatorId: z.number().nullable(),
  driverCustomerId: z.string().nullable(),
  driverRiderId: z.string().nullish(), // change to nullable in future
  customerWaiverId: z.string().uuid().nullable(),
  reservationVehicleId: z.string().uuid().nullable(),
  createdDate: isoZ.instant().nullable(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable(),
  serverLastModifiedDate: isoZ.instant().nullable(),
  vin: z.string().nullable(),
  vehicleId: z.number(),
  operatorUnitNumber: z.string().nullable(),
  damageWaiverPlanId: z.number().int().nullable(),
  checkOutDateTime: isoZ.instant().nullable(),
  checkOutEngineHours: z.number().nullable(),
  checkOutMileage: z.number().int().nullable(),
  checkOutTreadDepth32ndInches: z.number().int().nullable(),
  checkOutConditionNotes: z.string().nullable(),
  checkOutFormSnapshotUrl: z.string().nullable(),
  checkOutFuelLevel: z.string().nullable(),
  checkOutVehicleImages: vehicleImage.array().nullable(),
  rentalLengthHours: z.number().int().nullable(),
  dueBackDateTime: isoZ.instant().nullable(),
  checkInDateTime: isoZ.instant().nullable(),
  checkInEngineHours: z.number().nullable(),
  checkInMileage: z.number().int().nullable(),
  checkInTreadDepth32ndInches: z.number().int().nullable(),
  checkInConditionNotes: z.string().nullable(),
  checkInFormSnapshotUrl: z.string().nullable(),
  checkInVehicleImages: vehicleImage.array().nullable(),
  checkInDidCustomerHitAnything: z.boolean().nullable(),
  checkInDidVehicleHaveMechanicalOrElectricalIssue: z.boolean().nullable(),
  checkInFuelLevel: z.string().nullable(),
  checkInDamageReport: damageReportElement.array().nullable(),
  customerMachineRanOk: z.boolean().nullable(),
  gearUsage: gearUsageFragment.array().nullable(),
  insuranceCarrier: z.string().nullable(),
  insurancePolicyNumber: z.string().nullable(),
  towingVehicleLicensePlateNumber: z.string().nullable(),
  dealerReasonCode: z.string().nullable(),
  servicedVehicleVin: z.string().nullable(),
  serviceLoanerExplanation: z.string().nullable(),
  lastDeviceId: z.string().uuid().nullable()
})

export type vehicleUseHistoryModel = z.infer<typeof vehicleUseHistoryModel>
